import React from "react";
import { FiGlobe, FiPackage } from "react-icons/fi";
import "../../styles/loader.css";

function Loader({ text }) {
  return (
    <div className="loader-container">
      <div className="loader-animation">
        <div className="loader-globe">
          <FiGlobe size={48} color="#0f5132" />
        </div>
        <div className="loader-package loader-package-1">
          <FiPackage size={20} color="#14532d" />
        </div>
        <div className="loader-package loader-package-2">
          <FiPackage size={16} color="#1a6b45" />
        </div>
        <div className="loader-package loader-package-3">
          <FiPackage size={14} color="#2d8a5e" />
        </div>
      </div>
      {text && <p className="loader-text">{text}</p>}
    </div>
  );
}

export default Loader;
